import React from 'react';

const LazyPage404 = React.lazy(() =>
  import('./page404')
);

const Page404 = (props: Record<string, any>) => (
  <React.Suspense fallback={null}>
    <LazyPage404 {...props} />
  </React.Suspense>
);

export default Page404